import React, { Component } from 'react';
import __ from 'lodash';
import {Row, Col, Form} from 'react-bootstrap';

class SoalMcc extends Component {
    constructor(props) {
        super(props);
        this.state = {  
            filterOptions: [
                { value: "1", label: "A" },
                { value: "2", label: "B" },
                { value: "3", label: "C" },
                { value: "4", label: "D" },
                { value: "5", label: "E" }
              ],
            soal: this.props.soal,
            kunciJawaban: this.props.soal.kunciJawaban === undefined ? "" : this.props.soal.kunciJawaban.split(',')
           
        }
    }

    componentDidMount(){
        (function()
        {
          if( window.localStorage )
          {
            if( !localStorage.getItem('firstLoad') )
            {
              localStorage['firstLoad'] = true;
              window.location.reload();
            }  
            else
              localStorage.removeItem('firstLoad');
          }
        })();
    }
   
    handleChange = (e) => {   
       var options = e.target.options;
       var value = "";
        for (var i = 0, l = options.length; i < l; i++) {
            if (options[i].selected) {
                value += options[i].value + ',';
            }
        }    
        
        value = value.substring(0,value.length -1);
        this.setState({ kunciJawaban: value });
        this.props.handleChange(value)    
    }

    
    render() { 
        return (  
            <div className="content ">
            <Col sm={12}>                                 
            <Form.Group controlId="pertanyaan">
                    <Form.Label><h6>Pertanyaan: </h6></Form.Label>                        
                    <textarea className="tinymce_textarea" id="pertanyaan" value={this.state.soal.pertanyaan} required></textarea>    
                </Form.Group>               
                
                <Form.Group controlId="jawaban">                   
                <ul className="nav nav-tabs">
                    <li className="nav-item">
                        <a className="nav-link active" data-toggle="tab" href="#tab1">Jawaban A</a>
                    </li>                        
                    <li className="nav-item">
                        <a className="nav-link" data-toggle="tab" href="#tab2">Jawaban B</a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link" data-toggle="tab" href="#tab3">Jawaban C</a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link" data-toggle="tab" href="#tab4">Jawaban D</a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link" data-toggle="tab" href="#tab5">Jawaban E</a>
                    </li>  
                </ul>

                <div className="tab-content">
                    <div className="tab-pane active" id="tab1">
                        <textarea className="tinymce_textarea" id="jawab1" value={this.state.soal.jawab1} required></textarea> 
                    </div>
                    <div className="tab-pane" id="tab2">
                        <textarea className="tinymce_textarea" id="jawab2" value={this.state.soal.jawab2} required></textarea> 
                    </div>
                    <div className="tab-pane" id="tab3">
                        <textarea className="tinymce_textarea" id="jawab3" value={this.state.soal.jawab3} required></textarea> 
                    </div>
                    <div className="tab-pane" id="tab4">
                        <textarea className="tinymce_textarea" id="jawab4" value={this.state.soal.jawab4} required></textarea> 
                    </div>
                    <div className="tab-pane" id="tab5">
                        <textarea className="tinymce_textarea" id="jawab5" value={this.state.soal.jawab5} required></textarea> 
                    </div>                        
                </div>
                </Form.Group>

                <Form.Group as={Row} controlId="kunci">
                    <Form.Label column sm="2"><h6>Kunci Jawaban: </h6><span>Use Ctrl Key</span></Form.Label>                        
                    <Col sm="10"> 
                    <Form.Control as="select" multiple={true} name="kunciJawaban" style={{width: '120px'}} 
                        onChange={this.handleChange} value={this.state.kunciJawaban} required>
                        <option value="1">A</option>
                        <option value="2">B</option>
                        <option value="3">C</option>
                        <option value="4">D</option>
                        <option value="5">E</option>
                    </Form.Control>                 
                    </Col>
                </Form.Group>

                <Form.Group controlId="pembahasan">
                    <Form.Label><h6>Pembahasan: </h6></Form.Label>                        
                    <textarea className="tinymce_textarea" id="pembahasan" value={this.state.soal.isianJawaban} required></textarea>       
                </Form.Group>

            </Col> 
            </div>
        );
    }
}
 
export default SoalMcc;